'use client';

import { useRouter } from 'next/navigation';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export function BackButton() {
  const router = useRouter();

  const handleClick = () => {
    if (window.history.length > 1) {
      router.back();
    } else if (document.referrer) {
      window.location.href = document.referrer;
    } else {
      router.push('/');
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="inline-flex items-center gap-2 border border-sky-800 text-sky-800 hover:bg-sky-100 dark:border-sky-400 dark:text-sky-400 dark:hover:bg-slate-700 rounded-lg px-4 py-2 font-medium transition-all duration-200 mb-8 min-h-[44px] active:scale-[0.98] group"
    >
      <ArrowLeftIcon
        aria-hidden="true"
        focusable="false"
        className="w-5 h-5 transition-transform group-hover:-translate-x-1"
      />
      <span>Retour</span>
    </button>
  );
}
